import cookies from './auth/cookies';
const authHeader = 'Token ' + cookies.getCookie('access_token');

class BaseService {
  getAuthHeader() {
    return {
      Authorization: authHeader,
      'Content-Type': 'application/json',
    };
  }
}

export default BaseService;
